(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitment-guide-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const buildDiameters = new Set(['17', '18', '19', '20', '21', '22']);
    const normalizeKey = (value) => String(value || '').trim().toLowerCase();
    const diameterFromSize = (size) => String(size || '').split('x')[0] || '';
    const formatOffset = (value) => {
      const number = Number(value);
      if (!Number.isFinite(number)) return String(value || '');
      return number > 0 ? `+${number}` : String(number);
    };
    const formatSetupTitle = (setup) => {
      const [frontSize, frontOffset, rearSize, rearOffset] = setup;
      if (frontSize === rearSize && String(frontOffset) === String(rearOffset)) {
        return `${frontSize} ${formatOffset(frontOffset)}`;
      }
      return `Front ${frontSize} ${formatOffset(frontOffset)} / Rear ${rearSize} ${formatOffset(rearOffset)}`;
    };
    const setupType = (setup) => (setup[0] === setup[2] && String(setup[1]) === String(setup[3]) ? 'Square' : 'Staggered');
    const escapeHtml = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    const optionDiameter = (value) => String(value || '').match(/\d+/)?.[0] || '';
    const formatMoney = (cents) => {
      const currency = window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      }).format((Number(cents) || 0) / 100);
    };
    const fallbackFinishPalette = [
      { name: 'Gloss Black', hex: '#080808', premium: false, image: '' },
      { name: 'Matte Black', hex: '#141518', premium: false, image: '' },
      { name: 'Polished Gunmetal', hex: '#34363B', premium: true, image: '' },
      { name: 'Charcoal', hex: '#3F4348', premium: false, image: '' },
      { name: 'Dark Metallic Gray', hex: '#454A53', premium: true, image: '' },
      { name: 'Dark Gray', hex: '#484B52', premium: false, image: '' },
      { name: 'Graphite', hex: '#495057', premium: false, image: '' },
      { name: 'Slate Gray', hex: '#4F535B', premium: false, image: '' },
      { name: 'Brushed Aluminum', hex: '#8F949A', premium: true, image: '' },
      { name: 'Silver', hex: '#A2A8AE', premium: false, image: '' },
      { name: 'Polished Silver', hex: '#A3A7AD', premium: true, image: '' },
      { name: 'Matte Silver', hex: '#C1C6C8', premium: false, image: '' },
      { name: 'White', hex: '#D6DBDF', premium: false, image: '' },
      { name: 'Polished Gold', hex: '#C7A221', premium: true, image: '' },
      { name: 'Mustard Gold', hex: '#C1A54F', premium: false, image: '' },
      { name: 'Satin Gold', hex: '#BEA153', premium: false, image: '' },
      { name: 'Polished Brass', hex: '#B9AA70', premium: true, image: '' },
      { name: 'Light Brass', hex: '#C1AD7D', premium: false, image: '' },
      { name: 'Brushed Champagne', hex: '#B49F7D', premium: true, image: '' },
      { name: 'Pale Champagne', hex: '#C3B9A4', premium: false, image: '' },
      { name: 'Polished Copper', hex: '#9D6B3D', premium: true, image: '' },
      { name: 'Burnished Bronze', hex: '#704A2E', premium: false, image: '' },
      { name: 'Mocha Brown', hex: '#684C38', premium: false, image: '' },
      { name: 'Dark Olive Brown', hex: '#4A433A', premium: false, image: '' },
      { name: 'Dark Chocolate', hex: '#3D332D', premium: false, image: '' },
      { name: 'Rose Pink', hex: '#C25E73', premium: false, image: '' },
      { name: 'Crimson Red', hex: '#8B0D16', premium: false, image: '' },
      { name: 'Candy Apple Red', hex: '#77000B', premium: true, image: '' },
      { name: 'Violet', hex: '#58317F', premium: false, image: '' },
      { name: 'Deep Purple', hex: '#401D76', premium: true, image: '' },
      { name: 'Cyan Blue', hex: '#0078BD', premium: false, image: '' },
      { name: 'Electric Blue', hex: '#003EAC', premium: true, image: '' },
      { name: 'Cobalt Blue', hex: '#0048A5', premium: false, image: '' },
      { name: 'Neon Green', hex: '#9DC300', premium: false, image: '' },
      { name: 'Lime Green', hex: '#8DB21B', premium: true, image: '' },
      { name: 'Forest Green', hex: '#3F8829', premium: false, image: '' },
    ];
    const readFinishPalette = () => {
      const script = document.querySelector('[data-fitment-color-palette-data]');
      try {
        const values = JSON.parse(script?.textContent || '[]');
        const finishes = values
          .map((finish) => ({
            name: String(finish?.name || '').trim(),
            hex: String(finish?.hex || '#a2a8ae').trim(),
            premium: Boolean(finish?.premium),
            image: String(finish?.image || '').trim(),
          }))
          .filter((finish) => finish.name);
        return finishes.length ? finishes : fallbackFinishPalette;
      } catch (error) {
        return fallbackFinishPalette;
      }
    };
    const finishPalette = readFinishPalette();
    const finishByName = new Map(finishPalette.map((finish) => [normalizeKey(finish.name), finish]));
    const finishMeta = (name) => finishByName.get(normalizeKey(name)) || { name, hex: '#a2a8ae', premium: false, image: '' };

    const init = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const yearSelect = root.querySelector('[data-fitment-year]');
      const makeSelect = root.querySelector('[data-fitment-make]');
      const modelSelect = root.querySelector('[data-fitment-model]');
      const trimSelect = root.querySelector('[data-fitment-trim]');
      const diameterSelect = root.querySelector('[data-fitment-diameter]');
      const clearButton = root.querySelector('[data-fitment-clear]');
      const emptyState = root.querySelector('[data-fitment-empty]');
      const summary = root.querySelector('[data-fitment-summary]');
      const summaryKicker = root.querySelector('[data-fitment-summary-kicker]');
      const summaryTitle = root.querySelector('[data-fitment-summary-title]');
      const summaryNote = root.querySelector('[data-fitment-summary-note]');
      const suggestions = root.querySelector('[data-fitment-suggestions]');
      const shop = root.querySelector('[data-fitment-shop]');
      const selectedSetupText = root.querySelector('[data-fitment-selected-setup]');
      const wheelSelect = root.querySelector('[data-fitment-wheel-select]');
      const wheelGrid = root.querySelector('[data-fitment-wheel-grid]');
      const colorSelect = root.querySelector('[data-fitment-color]');
      const colorPalette = root.querySelector('[data-fitment-color-palette]');
      const colorNote = root.querySelector('[data-fitment-color-note]');
      const orderSummary = root.querySelector('[data-fitment-order-summary]');
      const addButton = root.querySelector('[data-fitment-add-to-cart]');
      const cartStatus = root.querySelector('[data-fitment-cart-status]');
      const productsScript = document.querySelector('[data-fitment-guide-products]');
      let products = [];
      let lookup = null;
      let currentRows = [];
      let selectedSetup = null;
      let selectedProductHandle = '';
      let selectedColor = '';

      try {
        products = JSON.parse(productsScript?.textContent || '[]').filter((product) => (product.variants || []).length > 0);
      } catch (error) {
        products = [];
      }

      const setOptions = (select, items, placeholder, disabled = false) => {
        select.replaceChildren(new Option(placeholder, ''));
        items.forEach((item) => {
          const label = typeof item === 'string' ? item : item.label;
          const value = typeof item === 'string' ? item : item.value;
          const option = new Option(label, value);
          if (typeof item !== 'string' && item.disabled) option.disabled = true;
          select.append(option);
        });
        select.disabled = disabled || items.length === 0;
      };

      const selectedVehicleName = () =>
        selectedVehicle()?.n || [yearSelect.value, makeSelect.value, modelSelect.value, trimSelect.value].filter(Boolean).join(' ');

      const clearPurchaseState = () => {
        selectedSetup = null;
        selectedProductHandle = '';
        selectedColor = '';
        if (shop) shop.hidden = true;
        if (wheelGrid) wheelGrid.innerHTML = '';
        if (wheelSelect) setOptions(wheelSelect, [], 'Select fitment first', true);
        if (colorSelect) setOptions(colorSelect, [], 'Select wheel first', true);
        if (colorPalette) {
          colorPalette.innerHTML = '';
          colorPalette.hidden = true;
        }
        if (colorNote) colorNote.textContent = '';
        if (orderSummary) orderSummary.textContent = 'Select a wheel design and color finish to add a 4-wheel set to cart.';
        if (addButton) {
          addButton.disabled = true;
          addButton.removeAttribute('aria-disabled');
        }
        if (cartStatus) cartStatus.textContent = '';
      };

      const optionIndex = (product, term) =>
        (product.optionNames || []).findIndex((name) => normalizeKey(name).includes(term));

      const variantsForFitment = (product) => {
        if (!selectedSetup) return [];
        const diameterIndex = optionIndex(product, 'diameter');
        return (product.variants || []).filter((variant) => {
          if (!variant.available) return false;
          if (diameterIndex < 0) return true;
          return optionDiameter(variant.options?.[diameterIndex]) === selectedSetup.diameter;
        });
      };

      const colorValue = (product, variant) => {
        const colorIndex = optionIndex(product, 'color');
        if (colorIndex < 0) return 'Default finish';
        return variant.options?.[colorIndex] || 'Default finish';
      };

      const variantColorsForFitment = (product) => [...new Set(variantsForFitment(product).map((variant) => colorValue(product, variant)))];

      const variantForColor = (product, finishName) =>
        variantsForFitment(product).find((variant) => normalizeKey(colorValue(product, variant)) === normalizeKey(finishName)) || null;

      const availableFinishesForProduct = (product) => {
        const colors = variantColorsForFitment(product);
        const colorKeys = new Set(colors.map(normalizeKey));
        const paletteMatches = finishPalette.filter((finish) => colorKeys.has(normalizeKey(finish.name)));
        const paletteKeys = new Set(paletteMatches.map((finish) => normalizeKey(finish.name)));
        const extras = colors
          .filter((color) => !paletteKeys.has(normalizeKey(color)))
          .map((color) => ({ ...finishMeta(color), name: color }));
        return [...paletteMatches, ...extras];
      };

      const basePriceForFitment = (product) => {
        const prices = variantsForFitment(product)
          .map((variant) => Number(variant.price))
          .filter((price) => Number.isFinite(price));
        return prices.length ? Math.min(...prices) : 0;
      };

      const finishPriceDeltaCents = (product, finishName) => {
        const variant = variantForColor(product, finishName);
        const basePrice = basePriceForFitment(product);
        if (!variant || !basePrice) return 0;
        return Math.max(0, Number(variant.price) - basePrice);
      };

      const finishPriceLabel = (finish, product) => {
        const delta = product ? finishPriceDeltaCents(product, finish.name) : 0;
        return delta > 0 ? `+ ${formatMoney(delta)} / wheel` : 'Included';
      };

      const variantForSelection = () => {
        const product = products.find((item) => item.handle === selectedProductHandle);
        if (!product) return null;
        if (selectedColor) return variantForColor(product, selectedColor);
        return variantsForFitment(product)[0] || null;
      };

      const renderColorPalette = () => {
        if (!colorPalette) return;
        const product = products.find((item) => item.handle === selectedProductHandle);
        const finishes = product ? availableFinishesForProduct(product) : [];
        colorPalette.hidden = finishes.length === 0;
        colorPalette.innerHTML = finishes
          .map((finish) => {
            const selected = normalizeKey(finish.name) === normalizeKey(selectedColor);
            const imageStyle = finish.image ? `--fitment-color-swatch-image: url('${escapeHtml(finish.image)}');` : '';
            return `<button class="fitment-hub__color-swatch${selected ? ' is-selected' : ''}" type="button" data-fitment-color-name="${escapeHtml(finish.name)}" style="--fitment-color-swatch: ${escapeHtml(finish.hex)}; ${imageStyle}">
              <span class="fitment-hub__swatch-dot" aria-hidden="true"></span>
              <span>
                <span class="fitment-hub__swatch-name">${escapeHtml(finish.name)}</span>
                <span class="fitment-hub__swatch-price">${escapeHtml(finishPriceLabel(finish, product))}</span>
              </span>
            </button>`;
          })
          .join('');
      };

      const syncOrderSummary = () => {
        const product = products.find((item) => item.handle === selectedProductHandle);
        const variant = variantForSelection();
        if (!product || !selectedSetup) {
          if (orderSummary) orderSummary.textContent = 'Select a wheel design and color finish to add a 4-wheel set to cart.';
          if (addButton) addButton.disabled = true;
          return;
        }

        if (!variant) {
          if (orderSummary) orderSummary.textContent = `${product.title} is not available in ${selectedSetup.diameter} inch right now.`;
          if (addButton) addButton.disabled = true;
          return;
        }

        if (orderSummary) {
          orderSummary.textContent = `${product.title} in ${selectedColor}. 4-wheel set ${formatMoney(variant.price * 4)} before shipping and taxes.`;
        }
        if (colorNote) {
          const charge = finishPriceDeltaCents(product, selectedColor);
          colorNote.textContent =
            charge > 0
              ? `${selectedColor} adds ${formatMoney(charge)} per wheel and is already included in the selected variant price.`
              : `${selectedColor || 'This finish'} is included.`;
        }
        if (addButton) addButton.disabled = false;
      };

      const renderColorOptions = () => {
        const product = products.find((item) => item.handle === selectedProductHandle);
        if (!product) {
          setOptions(colorSelect, [], 'Select wheel first', true);
          if (colorPalette) {
            colorPalette.innerHTML = '';
            colorPalette.hidden = true;
          }
          if (colorNote) colorNote.textContent = '';
          syncOrderSummary();
          return;
        }

        const finishes = availableFinishesForProduct(product);
        const colors = finishes.map((finish) => ({
          label: `${finish.name} - ${finishPriceLabel(finish, product)}`,
          value: finish.name,
        }));
        if (!finishes.some((finish) => normalizeKey(finish.name) === normalizeKey(selectedColor))) {
          selectedColor =
            finishes.find((finish) => normalizeKey(finish.name) === 'silver')?.name ||
            finishes[0]?.name ||
            '';
        }
        setOptions(colorSelect, colors, colors.length ? 'Select color finish' : 'No finish available', colors.length === 0);
        colorSelect.value = selectedColor;
        renderColorPalette();
        syncOrderSummary();
      };

      const renderWheelProducts = () => {
        if (!wheelGrid) return;
        if (products.length === 0) {
          wheelGrid.innerHTML = '<p class="fitment-hub__suggestion-note">Wheel products are unavailable right now. Refresh the page or shop the wheels collection.</p>';
          renderColorOptions();
          return;
        }

        const productOptions = products.map((product) => ({
          label: product.title,
          value: product.handle,
          disabled: variantsForFitment(product).length === 0,
        }));
        const firstAvailable = productOptions.find((option) => !option.disabled)?.value || productOptions[0]?.value || '';

        if (!selectedProductHandle || !products.some((product) => product.handle === selectedProductHandle)) {
          selectedProductHandle = firstAvailable;
        }
        if (productOptions.find((option) => option.value === selectedProductHandle)?.disabled && firstAvailable) {
          selectedProductHandle = firstAvailable;
        }

        if (wheelSelect) {
          setOptions(wheelSelect, productOptions, 'Select wheel design', productOptions.length === 0);
          wheelSelect.value = selectedProductHandle;
        }

        wheelGrid.innerHTML = products
          .map((product) => {
            const isSelected = product.handle === selectedProductHandle;
            const available = variantsForFitment(product).length > 0;
            const image = product.image
              ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="84" height="84">`
              : '<span aria-hidden="true"></span>';
            return `<button class="fitment-hub__wheel-card${isSelected ? ' is-selected' : ''}" type="button" data-fitment-product-handle="${escapeHtml(product.handle)}" ${available ? '' : 'disabled'}>
              ${image}
              <span>
                <strong>${escapeHtml(product.title)}</strong>
                <span>${available ? `From ${escapeHtml(product.priceText)}` : `${escapeHtml(selectedSetup?.diameter || '')} inch unavailable`}</span>
              </span>
            </button>`;
          })
          .join('');
        renderColorOptions();
      };

      const renderShop = () => {
        if (!shop) return;
        if (!selectedSetup) {
          shop.hidden = true;
          syncOrderSummary();
          return;
        }

        shop.hidden = false;
        if (selectedSetupText) {
          selectedSetupText.textContent = `${setupType(selectedSetup.setup)}: ${formatSetupTitle(selectedSetup.setup)}`;
        }
        if (cartStatus) cartStatus.textContent = '';
        renderWheelProducts();
      };

      const vehicleKey = () =>
        [yearSelect.value, normalizeKey(makeSelect.value), normalizeKey(modelSelect.value), normalizeKey(trimSelect.value)].join('|');

      const selectedVehicle = () => lookup?.vehicles?.[vehicleKey()] || null;

      const vehicleSetups = (vehicle) => {
        if (!vehicle || !lookup) return [];
        const rows = [];
        (vehicle.c || []).forEach((id) => {
          const combo = lookup.combinations?.[id];
          (combo?.f || []).forEach((setup) => rows.push({ setup, combo }));
        });
        (vehicle.f || []).forEach((setup) => rows.push({ setup, combo: vehicle }));
        return rows;
      };

      const availableDiameters = (vehicle) => {
        const values = new Set();
        vehicleSetups(vehicle).forEach(({ setup }) => {
          [diameterFromSize(setup[0]), diameterFromSize(setup[2])].forEach((diameter) => {
            if (buildDiameters.has(diameter)) values.add(diameter);
          });
        });
        return [...values].sort((a, b) => Number(a) - Number(b));
      };

      const showEmpty = (title, text) => {
        emptyState.hidden = false;
        summary.hidden = true;
        suggestions.hidden = true;
        emptyState.querySelector('h2').textContent = title;
        emptyState.querySelector('p').textContent = text;
        clearPurchaseState();
      };

      const renderSuggestions = () => {
        const vehicle = selectedVehicle();
        const diameter = diameterSelect.value;
        if (!vehicle || !diameter) {
          showEmpty('Start with your vehicle', 'Select year, manufacturer, model, trim, and rim diameter to unlock fitment suggestions.');
          return;
        }

        const boltPattern = vehicle.b?.[0] || 'Custom bolt pattern';
        const rows = vehicleSetups(vehicle)
          .filter(({ setup }) => diameterFromSize(setup[0]) === diameter && diameterFromSize(setup[2]) === diameter)
          .map(({ setup, combo }) => ({
            setup,
            combo,
            key: [setup[0], setup[1], setup[2], setup[3]].join('|'),
            score: Number(setup[6]) || 0,
          }))
          .filter((item, index, array) => array.findIndex((other) => other.key === item.key) === index)
          .sort((a, b) => b.score - a.score)
          .slice(0, 12);
        currentRows = rows.map((row) => ({
          ...row,
          diameter,
          boltPattern,
          vehicleName: selectedVehicleName(),
        }));
        if (selectedSetup && !currentRows.some((row) => row.key === selectedSetup.key)) {
          selectedSetup = null;
          selectedProductHandle = '';
          selectedColor = '';
        }

        if (currentRows.length === 0) {
          const available = availableDiameters(vehicle);
          const availableText = available.length ? `Available buildable diameters in our data: ${available.join(', ')}.` : 'No 17-22 inch suggestions are available for this trim yet.';
          showEmpty('No exact diameter match', availableText);
          return;
        }

        emptyState.hidden = true;
        summary.hidden = false;
        suggestions.hidden = false;
        summaryKicker.textContent = `${currentRows.length} fitment suggestion${currentRows.length === 1 ? '' : 's'}`;
        summaryTitle.textContent = vehicle.n || [yearSelect.value, makeSelect.value, modelSelect.value, trimSelect.value].join(' ');
        summaryNote.textContent = `${diameter} inch rim diameter. Bolt pattern: ${boltPattern}. Suggestions are ranked by fitment data strength.`;
        suggestions.innerHTML = currentRows
          .map(({ setup, score, key }) => {
            const [frontSize, frontOffset, rearSize, rearOffset] = setup;
            const isSelected = selectedSetup?.key === key;
            return `<article class="fitment-hub__suggestion${isSelected ? ' is-selected' : ''}">
              <div class="fitment-hub__suggestion-head">
                <div>
                  <p class="fitment-hub__suggestion-kicker">${escapeHtml(setupType(setup))} setup</p>
                  <h3>${escapeHtml(formatSetupTitle(setup))}</h3>
                </div>
                <span class="fitment-hub__badge">${escapeHtml(diameter)} inch</span>
              </div>
              <dl class="fitment-hub__spec-grid">
                <div class="fitment-hub__spec"><dt>Front</dt><dd>${escapeHtml(frontSize)} ET${escapeHtml(formatOffset(frontOffset))}</dd></div>
                <div class="fitment-hub__spec"><dt>Rear</dt><dd>${escapeHtml(rearSize)} ET${escapeHtml(formatOffset(rearOffset))}</dd></div>
                <div class="fitment-hub__spec"><dt>Bolt pattern</dt><dd>${escapeHtml(boltPattern)}</dd></div>
              </dl>
              <p class="fitment-hub__suggestion-note">Fitment confidence score: ${escapeHtml(score.toLocaleString('en-US'))}. Confirm final tire, brake, suspension, and alignment clearance before ordering.</p>
              <button class="fitment-hub__select-fitment" type="button" data-fitment-setup-key="${escapeHtml(key)}">${isSelected ? 'Selected fitment' : 'Select this fitment'}</button>
            </article>`;
          })
          .join('');
        renderShop();
      };

      const loadYears = () => {
        setOptions(yearSelect, lookup.years || [], 'Select year');
      };

      const loadMakes = () => {
        setOptions(makeSelect, lookup.makes?.[yearSelect.value] || [], 'Select manufacturer', !yearSelect.value);
        setOptions(modelSelect, [], 'Select model', true);
        setOptions(trimSelect, [], 'Select trim', true);
        setOptions(diameterSelect, [], 'Select diameter', true);
        renderSuggestions();
      };

      const loadModels = () => {
        const key = [yearSelect.value, normalizeKey(makeSelect.value)].join('|');
        setOptions(modelSelect, lookup.models?.[key] || [], 'Select model', !makeSelect.value);
        setOptions(trimSelect, [], 'Select trim', true);
        setOptions(diameterSelect, [], 'Select diameter', true);
        renderSuggestions();
      };

      const loadTrims = () => {
        const key = [yearSelect.value, normalizeKey(makeSelect.value), normalizeKey(modelSelect.value)].join('|');
        setOptions(trimSelect, lookup.trims?.[key] || [], 'Select trim', !modelSelect.value);
        setOptions(diameterSelect, [], 'Select diameter', true);
        renderSuggestions();
      };

      const loadDiameters = () => {
        const vehicle = selectedVehicle();
        const diameters = availableDiameters(vehicle);
        setOptions(
          diameterSelect,
          diameters.map((diameter) => ({ label: `${diameter} inch`, value: diameter })),
          diameters.length ? 'Select diameter' : 'No 17-22 inch data',
          !vehicle || diameters.length === 0
        );
        renderSuggestions();
      };

      const cleanProperties = (properties) =>
        Object.entries(properties).reduce((memo, [key, value]) => {
          const cleanValue = String(value || '').trim();
          if (cleanValue) memo[key] = cleanValue;
          return memo;
        }, {});

      const addSelectedToCart = async () => {
        const variant = variantForSelection();
        const product = products.find((item) => item.handle === selectedProductHandle);
        if (!selectedSetup || !variant) {
          if (cartStatus) cartStatus.textContent = 'Select a fitment, wheel, and color finish first.';
          return;
        }

        const [frontSize, frontOffset, rearSize, rearOffset] = selectedSetup.setup;
        const item = {
          id: Number(variant.id),
          quantity: 4,
          properties: cleanProperties({
            'Fitment source': 'Fitment guide',
            'Wheel design': product?.title,
            Vehicle: selectedSetup.vehicleName,
            Setup: `${setupType(selectedSetup.setup)} setup`,
            'Front wheel': `${frontSize} ${formatOffset(frontOffset)}`,
            'Rear wheel': `${rearSize} ${formatOffset(rearOffset)}`,
            'Bolt pattern': selectedSetup.boltPattern,
          }),
        };
        const payload = { items: [item] };
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (cart?.getSectionsToRender) {
          payload.sections = cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          cart.setActiveElement?.(document.activeElement);
        }

        if (addButton) {
          addButton.disabled = true;
          addButton.setAttribute('aria-disabled', 'true');
          addButton.textContent = 'Adding...';
        }
        if (cartStatus) cartStatus.textContent = '';

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const data = await response.json();

          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Unable to add this wheel set to cart.');
          }

          if (cart && data.sections) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'fitment-guide',
                productVariantId: String(item.id),
                cartData: data,
              });
            }
            cart.renderContents(data);
          } else {
            window.location = window.routes?.cart_url || '/cart';
            return;
          }

          if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
          if (cartStatus) cartStatus.textContent = 'Added to cart.';
        } catch (error) {
          if (cartStatus) cartStatus.textContent = error?.message || 'Unable to add this wheel set to cart.';
        } finally {
          if (addButton) {
            addButton.textContent = 'Add selected wheels to cart';
            addButton.removeAttribute('aria-disabled');
          }
          syncOrderSummary();
        }
      };

      yearSelect.addEventListener('change', loadMakes);
      makeSelect.addEventListener('change', loadModels);
      modelSelect.addEventListener('change', loadTrims);
      trimSelect.addEventListener('change', loadDiameters);
      diameterSelect.addEventListener('change', renderSuggestions);
      suggestions.addEventListener('click', (event) => {
        const button = event.target.closest('[data-fitment-setup-key]');
        if (!button) return;
        const setup = currentRows.find((row) => row.key === button.dataset.fitmentSetupKey);
        if (!setup) return;
        selectedSetup = setup;
        selectedProductHandle = selectedProductHandle || products[0]?.handle || '';
        selectedColor = '';
        renderSuggestions();
      });
      wheelGrid?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-fitment-product-handle]');
        if (!button || button.disabled) return;
        selectedProductHandle = button.dataset.fitmentProductHandle;
        selectedColor = '';
        renderWheelProducts();
      });
      wheelSelect?.addEventListener('change', () => {
        selectedProductHandle = wheelSelect.value;
        selectedColor = '';
        renderWheelProducts();
      });
      colorSelect?.addEventListener('change', () => {
        selectedColor = colorSelect.value;
        renderColorPalette();
        syncOrderSummary();
      });
      colorPalette?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-fitment-color-name]');
        if (!button) return;
        selectedColor = button.dataset.fitmentColorName;
        if (colorSelect) colorSelect.value = selectedColor;
        renderColorPalette();
        syncOrderSummary();
      });
      addButton?.addEventListener('click', addSelectedToCart);
      clearButton.addEventListener('click', () => {
        loadYears();
        setOptions(makeSelect, [], 'Select manufacturer', true);
        setOptions(modelSelect, [], 'Select model', true);
        setOptions(trimSelect, [], 'Select trim', true);
        setOptions(diameterSelect, [], 'Select diameter', true);
        showEmpty('Start with your vehicle', 'Select year, manufacturer, model, trim, and rim diameter to unlock fitment suggestions.');
      });

      fetch(root.dataset.lookupUrl)
        .then((response) => {
          if (!response.ok) throw new Error('Fitment data failed to load.');
          return response.json();
        })
        .then((data) => {
          lookup = data;
          loadYears();
          showEmpty('Start with your vehicle', 'Select year, manufacturer, model, trim, and rim diameter to unlock fitment suggestions.');
        })
        .catch(() => {
          showEmpty('Fitment data unavailable', 'Refresh the page and try again. If this continues, contact EKW support with your vehicle details.');
        });
    };

    const initAll = () => document.querySelectorAll('[data-fitment-guide-tool]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
